<template>
    
    <div class="label-item"
        :class="[{'select':label.isSelected,'hover':label.isHovered,'editing':label.isEditing},label.getObjectType()]"
        @mouseenter="$emit('enter')"
        @mouseleave="$emit('leave')"
        @click="$emit('select')"
        >
        <div class="line" @dblclick.stop="onEdit">
            <div class="left">
                <div class="image">
                    <tooltip delay="0.5s" :text="$t(label.getLabelObject())">
                        <i class="fal" :class="typeIco"  v-if="!label.hasImage()"></i>
                        <img :src="label.getImage()" v-else>
                    </tooltip>
                </div>
                <div class="text" v-if="label.getObjectType() === 'text'">
                    {{label.text}}
                </div>
                <div class="link">
                    <div class="text no-link" v-if="!label.link.exist()">Not Linked</div>
                    <div class="text linked" v-else>
                        <tooltip :text="$t(label.link.type)" delay="0.5s">
                            <i class="fal" :class="label.link.getIco()"></i>
                            {{label.link.getTitle()}}
                        </tooltip>
                    </div>
                </div>
            </div>
            <div class="buttons pr-1">
                <div class="weight" v-if="label.hasImage()">
                    {{ label.image.sizeToString() }}
                </div>
                <div class="btn square item grip" v-if="type === 'all'">
                    <tooltip delay="0.5s" :text="$t('Grip')">
                        <i class="fal fa-grip-horizontal"></i>
                    </tooltip>
                </div>
                <div class="btn square item" @click="$emit('transfer')">
                    <tooltip delay="0.5s" :text="$t('Transfer')" position="top">
                        <i class="fal fa-exchange"></i>
                    </tooltip>
                </div>
                <div class="btn square item" @click="$emit('link')">
                    <tooltip delay="0.5s" :text="$t('Link')">
                        <i class="fal fa-link"></i>
                    </tooltip>
                </div>
                <div class="btn square item remove" @click="remove">
                    <tooltip delay="0.5s" :text="$t('Remove')">
                        <i class="fal fa-trash"></i>
                    </tooltip>
                </div>
                <div class="btn square item" @click="$emit('edit')" v-if="!label.isEditing">
                    <tooltip delay="0.5s" :text="$t('Edit')" position="top">
                        <i class="fal fa-edit"></i>
                    </tooltip>
                </div>
                <div class="btn square item" @click="label.unedit()" v-if="label.isEditing">
                    <tooltip delay="0.5s" :text="$t('Close')" position="top">
                        <i class="fal fa-times" v-if="!hasChange"></i>
                        <i class="fal fa-save" v-else></i>
                    </tooltip>
                </div>
            </div>
        </div>
        <div class="label-edition" @dblclick.stop>
            <InteractiveImage_Label_Edit
                v-if="label.isEditing"
                :label="label"
            />
        </div>
    </div>
</template>

<script>
    import InteractiveImage_Label_Edit from "@/views/interactives-images/InteractiveImage_Label_Edit";
    import LinkContent from "@/modules/links/LinkContent";
    import Tooltip from "@/modules/tooltip";
    import {panorama} from "@/class/panorama/panorama";
    import {interactiveImage} from "@/class/interactive-image/interactiveImage";
    import {contentPage} from "@/class/content-page/contentPage";
    import {annotation} from "@/class/annotation/annotation";
    export default {
        name: "Label_Small",
        components: {Tooltip, LinkContent,InteractiveImage_Label_Edit},
        props: {
            label: {type: Object},
            type:{type:String}
        },
        data(){
            return {
                hasChange:false,
            }
        },
        computed:{
            typeIco(){
                return this.label.getIconObject()
            },
            change(){
                return false
            }
        },
        methods: {
            addLink(){
            
            },
            removeLink(){
                this.label.link.delete();
            },
            remove(){
                return this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: this.$t('Confirm'),
                    text: this.$t("Do you really want to remove this label ?"),
                    acceptText:this.$t('Yes, remove it'),
                    cancelText:this.$t('No'),
                    accept: () => {
                        this.$emit("remove")
                    }
                })
            },
            onEdit(){
                this.hasChange = false
                if(this.label.isEditing){
                    this.label.unedit();
                }else{
                    this.$emit('edit')
                }
            }
        },
        watch:{
            change:{
                handler(){
                    this.hasChange = true
                },
                deep:true
            }
        },
    }
</script>